import { render, staticRenderFns } from "./OrderCollect.vue?vue&type=template&id=ada5cdb8&scoped=true&"
import script from "./OrderCollect.vue?vue&type=script&lang=js&"
export * from "./OrderCollect.vue?vue&type=script&lang=js&"
import style0 from "./OrderCollect.vue?vue&type=style&index=0&id=ada5cdb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada5cdb8",
  null
  
)

export default component.exports